import React, { useState } from "react"
import PropTypes from "prop-types"
import { ContentBox, Box } from "src/components/Grid"
import moment from "moment"
import get from "lodash/get"
import {
  DropdownDownIcon,
  DropdownUpIcon,
  WarningOutlineIcon,
} from "@infotech/uikit-icons"

import styles from "./styles.css"

const iconColor = `#adadad`

const dateWithTime = date => moment(date).format(`DD.MM.YYYY, HH:mm`)

const CategoryBody = props => {
  const {
    data,
    id,
    history,
    resourceRedirectPath,
    history: {
      location: { pathname, search },
    },
  } = props
  const isEvent = Boolean(get(data, `event`))
  const isResource = Boolean(get(data, `resource`))

  const startDateTime = get(data, `event.startDateTime`)
  const endDateTime = get(data, `event.endDateTime`)
  return (
    <>
      {data.violations &&
        data.violations.map(item => (
          <Box loose p="2md" flex raw className={styles[`validate-wrapper`]}>
            <Box loose className={styles[`validate-icon`]}>
              <WarningOutlineIcon
                color={item.level === `ERROR` ? `#f40104` : `#fbe05d`}
              />
            </Box>
            <Box pl="2md" pt="4px" loose className={styles[`validate-message`]}>
              <Box loose className={styles[`message-header`]}>
                {data[id].name}
              </Box>
              {isEvent && (
                <Box loose flex className={styles.EventDateText}>
                  <span>{dateWithTime(startDateTime)}</span>
                  <span style={{ paddingLeft: `4px`, paddingRight: `4px` }}>
                    —
                  </span>
                  <span>{dateWithTime(endDateTime)}</span>
                </Box>
              )}
              <Box loose pt="1md" className={styles[`message-text`]}>
                {item.message}
              </Box>
              {isEvent && (
                <Box
                  loose
                  pt="1md"
                  onClick={() => {
                    history.push(
                      `${pathname}/events/${get(data, `event.uuid`)}${search ||
                        ``}`,
                    )
                  }}
                  className={styles[`link-text`]}
                >
                  Открыть событие
                </Box>
              )}
              {isResource && (
                <Box
                  loose
                  pt="1md"
                  onClick={() => history.push(resourceRedirectPath)}
                  className={styles[`link-text`]}
                >
                  Открыть ресурс
                </Box>
              )}
            </Box>
          </Box>
        ))}
    </>
  )
}
const Category = ({
  label,
  data,
  id,
  count,
  history,
  resourceRedirectPath,
}) => {
  const [activeCategory, handleActiveCategory] = useState(false)
  const icon = activeCategory ? (
    <DropdownUpIcon color={iconColor} />
  ) : (
    <DropdownDownIcon color={iconColor} />
  )
  return (
    <li className={styles.ListStyles}>
      <ContentBox
        className={styles.header}
        onClick={() => handleActiveCategory(!activeCategory)}
        flex
        justify="space-between"
        align="center"
        bb
      >
        {`${label} (${count || 0})`}
        {icon}
      </ContentBox>
      {id === `plan`
        ? activeCategory && (
            <CategoryBody
              data={data}
              id={id}
              history={history}
              resourceRedirectPath={resourceRedirectPath}
            />
          )
        : activeCategory &&
          data.map(item => (
            <CategoryBody
              data={item}
              id={id}
              history={history}
              resourceRedirectPath={resourceRedirectPath}
            />
          ))}
    </li>
  )
}

Category.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      eventViolations: PropTypes.arrayOf(
        PropTypes.shape({
          event: PropTypes.shape({
            description: PropTypes.string.isRequired,
            endDateTime: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            eventTypeId: PropTypes.number.isRequired,
            planInfo: PropTypes.shape({
              id: PropTypes.number.isRequired,
              locked: PropTypes.bool.isRequired,
              name: PropTypes.string.isRequired,
            }),
            repeatable: PropTypes.bool.isRequired,
            startDateTime: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
          }),
          violations: PropTypes.arrayOf(
            PropTypes.shape({
              level: PropTypes.string.isRequired,
              message: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
      planViolations: PropTypes.shape({
        plan: PropTypes.shape({
          startDateTime: PropTypes.number.isRequired,
          endDateTime: PropTypes.number.isRequired,
          id: PropTypes.number.isRequired,
          locked: PropTypes.bool.isRequired,
          name: PropTypes.string.isRequired,
        }),
        violations: PropTypes.arrayOf(
          PropTypes.shape({
            level: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
          }),
        ),
      }),
      resourceViolations: PropTypes.arrayOf(
        PropTypes.shape({
          resource: PropTypes.shape({
            description: PropTypes.string.isRequired,
            endDateTime: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            resourceTypeId: PropTypes.number.isRequired,
            planInfo: PropTypes.shape({
              id: PropTypes.number.isRequired,
              locked: PropTypes.bool.isRequired,
              name: PropTypes.string.isRequired,
            }),
            repeatable: PropTypes.bool.isRequired,
            startDateTime: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
          }),
          violations: PropTypes.arrayOf(
            PropTypes.shape({
              level: PropTypes.string.isRequired,
              message: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
    }),
  ),
  count: PropTypes.number.isRequired,
}
Category.defaultProps = {
  data: [],
}

export default Category
